import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'
import { Button, WContainer, WImage } from '@next-nx/shared-ui/atoms'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './VantaggiHome.module.sass'
import ArrowRight from '../../atoms/Icons/ArrowRight'


interface Props {
  item?: MenuItemType | undefined
  className?: string
}

const VantaggiHome = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, c?: string, t?: string, cta?: string) => {
    const action_timestamp = getTimestamp() 
    
    linkDataLayer({
      virtual: 'action', 
      action_name: 'navigazione',  
      action_tech: 'click', 
      action_type: cta?.replace(/\.|\/|\s+/g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'interazione_componente_nlt',
    }) 
  }

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.content}>
          <p className={styles.title}>{item.name}</p>
          <div className={styles.wrap}>
            {item.children?.edges?.length && (
              <div className={styles.list}>
                {item.children.edges.map(x => x.node).map(x => (
                  <div className={styles.item} key={x.pk}>
                    {!!getIcon(x.style) && (
                      <div className={styles.itemIcon}>
                        {getIcon(x.style)}
                      </div>
                    )}
                    {!!x.name && <p className={styles.itemTitle}>{x.name}</p>}
                    {!!x.description && <div className={styles.itemDescription} dangerouslySetInnerHTML={{ __html: x.description }} />}
                  </div>
                ))}
              </div>
            )}
            {item.ctaLabel && item.url && (
              <div className={styles.ctaBox}>
                <Button label={item.ctaLabel} href={item.url} newPage={item.blank} variant="ghost" color='white' icon={<ArrowRight />} handleTracking={handleTracking} iconPos="right" />
              </div>
            )}
          </div>
        </div>
      </WContainer>
      <div className={styles.imageBox}>
        <WImage 
          src={item.image}
          alt={item.name}
          title={item.name}
          maxWidth={529}
          maxHeight={367}
          layout="fill"
          objectFit="contain"
          objectPosition="bottom right"
        />
      </div>
    </div>
  ) : <></>
}

export default VantaggiHome
